import { ReactNode } from "react";

type Props = {
  color?: string;
  children: ReactNode;
};

export default function EstateFridgeBody({ color = "lightBlue2", children }: Props) {
  return (
    <div
      data-mz-accent={color}
      className="relative flex flex-col min-h-0 grow shrink w-[51.375rem] max-h-[48.875rem] bg-dark-900 rounded-4 overflow-clip"
    >
      {children}
    </div>
  );
}
